{
  /**
   * hero-sliderのswiperを初期化
   */
  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('#js-heroSlider', {
      // Optional parameters
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1,
      speed: 5000, // スライドアニメーションのスピード（ミリ秒）

      autoplay: { // 自動再生させる
        delay: 5000, // 次のスライドに切り替わるまでの時間（ミリ秒）
        disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }, false)
}